<template lang="pug">
    div.mt-2.d-flex.align-center(style="overflow:hidden;")
        //
        v-menu(offset-y open-on-hover top)
            v-btn.mb-3(style="width: 50%;" @click="disableDiscount()" :color="active ? 'amber darken-2' : colors.primary" block slot="activator" depressed dark) Descuento 
            v-list
                v-list-tile(style="height: 30px; overflow: hidden;")
                        v-layout.pb-3()
                            v-flex.xs6.text-sm-center
                                v-btn.pr-3.display-1.text-sm-center.font-weight-bold.green--text(@click="activateDiscount()" depressed) %
                            v-divider(vertical)
                            v-flex.xs6.text-sm-center(style="cursor: not-allowed;")
                                v-btn.pl-3.display-1.text-sm-center.font-weight-bold.light-green--text.text--darken-2(@click="activateDiscount('$')" depressed) $
        v-text-field.px-3.white#gbdc(
            v-show="active"
            :prefix="inputFormat == '$' ? inputFormat : ''"
            :suffix="inputFormat == '%' ? inputFormat : ''"
            style="width:12%; position:absolute; left: 13%;"
            type="number"
            @blur="active = false"
            min="1"
            v-model="discountValue"
            ref="gbdc"
            @keyup.enter="$event.target.blur()"
        )
        span.pb-2.text-sm-center.display-1.px-3(style="width: 50%;") {{formatedDiscount}}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils'
export default {
    name: 'global-discount',
    props: {},
    data: function() {
        return {
            active: false,
            inputFormat: '#',
        }
    },
    computed: {
        ...mapState('CartModule', {
            globalDiscount: 'globalDiscount',
            items: 'items',
        }),
        discountType: function() {
            if (this.globalDiscount.percentage_discount != null) return '%'
            if (this.globalDiscount.amount_discount != null) return '$'
            return null
        },
        formatedDiscount: function() {
            if (this.discountType == '%')
                return this.globalDiscount.percentage_discount + '%'
            if (this.discountType == '$')
                return (
                    '$' +
                    this.mixCurrencyFormatter(
                        this.globalDiscount.amount_discount
                    )
                )
            return '-'
        },
        discountValue: {
            get: function() {
                if (
                    !this.globalDiscount.percentage_discount &&
                    !this.globalDiscount.amount_discount
                )
                    this.active = false
                if (this.discountType == '%')
                    return this.globalDiscount.percentage_discount
                if (this.discountType == '$')
                    return this.globalDiscount.amount_discount
                return null
            },
            set: function(val) {
                if (this.inputFormat == '%') {
                    if (val >= 100) val = 99
                    this.setGlobalDiscount({
                        percentage_discount: val,
                        amount_discount: null,
                    })
                }
                if (this.inputFormat == '$') {
                    if (val >= this.total) val = this.total - 1
                    this.setGlobalDiscount({
                        percentage_discount: null,
                        amount_discount: val,
                    })
                }
                if (!val)
                    this.setGlobalDiscount({
                        percentage_discount: null,
                        amount_discount: null,
                    })
                this.setCartItems(JSON.parse(JSON.stringify(this.items)))
            },
        },
        total: function() {
            let sum = 0
            this.items.forEach(item => (sum += item.subtotal))
            return sum
        },
    },
    methods: {
        activateDiscount: function(type = '%') {
            this.active = true
            this.inputFormat = type
            this.$nextTick(() => this.$refs.gbdc.focus())
        },
        disableDiscount: function() {
            this.active = false
        },
        ...mapActions('CartModule', {
            setGlobalDiscount: 'setGlobalDiscount',
            setCartItems: 'setCartItems',
        }),
    },
    watch: {
        /*
        globalDiscount: {
            deep: true,
            immediate: true,
            handler(v) {
                if (v.amount_discount) this.activateDiscount('$')
                if (v.percentage_discount) this.activateDiscount()
            },
        },
        */
    },
    components: {},
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
